<template>
  <label
    ref="validationLabel"
    :for="elementId"
    :class="{ warn: showWarning }"
    >{{ getText }}</label
  >
</template>

<script lang="ts">
import { ref } from "vue";

export default {
  name: "ValidationLabel",
  props: {
    elementId: { type: String, required: true },
    text: { type: String, required: true },
    abbreviatedText: { default: "", required: false }
  },
  data() {
    return {
      receivedFocusFromMouse: false,
      minValue: 1,
      maxValue: 1000000,
      showWarning: false,
      warningText: ""
    };
  },
  setup() {
    const validationLabel = ref(null);

    return {
      validationLabel
    };
  },
  methods: {
    warn(warning: string) {
      this.warningText = warning;
      this.showWarning = true;
    },
    hideAnyWarnings() {
      this.warningText = "";
      this.showWarning = false;
    }
  },
  computed: {
    getText() {
      if (!this.showWarning) {
        return this.text;
      }

      if (this.warningText?.length > 0) {
        const mainText = this.abbreviatedText.length > 0 ? this.abbreviatedText : this.text;
        return `${mainText} ${this.warningText}`;
      }

      return this.text;
    }
  }
};
</script>

<style scoped>
.warn {
  color: #003d99;
}
</style>
